// angular.module('uniqueFilter', [])
angular.module('Filters')
.filter('onlyUnique', ['$filter', function ($filter) {
  return function (value, index, self) {
  	return self.indexOf(value) === index;
  };
}]);